import { differenceInYears, isValid, parse } from 'date-fns';
import { es } from 'date-fns/locale';

const esAlumnoMenor = (fecha) => {
  if (!fecha || fecha === '') {
    return null;
  }

  let fechaNacimiento;

  if (fecha instanceof Date) {
    fechaNacimiento = fecha;
  } else if (typeof fecha === 'string') {
    const dateParts = fecha.split('/');

    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const year = parseInt(dateParts[2], 10);

      fechaNacimiento = new Date(year, month, day);
    } else {
      const parsed = parse(fecha, 'dd/MM/yyyy', new Date(), { locale: es });
      if (isValid(parsed)) {
        fechaNacimiento = parsed;
      }
    }
  }

  if (fechaNacimiento && isValid(fechaNacimiento)) {
    const edadEnAnios = differenceInYears(new Date(), fechaNacimiento);
    return edadEnAnios < 18;
  }

  return null;
};

export default esAlumnoMenor;
